export { default } from './SmallImageThumbnail';
